import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const MINUTE = () => {
  return (
    <CardSection id="MINUTE" title="MINUTE">
      <Paragraph>날짜/시간 객체에서 분을 추출합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>MINUTE(DATETIME)</Paragraph>
        <Ul>
          <Li>
            <b>DATETIME</b>은 분을 추출하려는 날짜입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>MINUTE(`DATE`)</Paragraph>
        <Img src="computeMinute" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          <b>DATETIME</b>은 날짜/시간 객체, 날짜/시간 객체를 포함하는 열 또는
          날짜/시간 객체를 반환하는 함수여야 합니다.
        </Paragraph>
        <Paragraph>반환하는 값의 범위는 0부터 59까지 입니다.</Paragraph>
      </ListSection>
    </CardSection>
  );
};
